import {Injectable} from '@angular/core';
import { Router } from '@angular/router';
import {AuthService} from '../services/auth/auth.service';
import {StorageMap} from '@ngx-pwa/local-storage';

@Injectable({
  providedIn: 'root'
})
export class UnAuthGuard  {
  constructor(
    private storage: StorageMap,
    private authSrv: AuthService,
    private router: Router

  ) {
  }

  canActivate(): Promise<boolean> {
    return new Promise(async (resolve) => {
      const isLogged = await this.authSrv.isReallyLogged();
      if (isLogged) {
        const language = await this.storage.get('language').toPromise();
        await this.router.navigate(['/', language, 'learning', 'dashboard']);
        resolve(false);
      } else {
        resolve(true);
      }
    });
  }

}
